/* Safely parsing of numbers */
(function ($) {
    $.mw_tryParseFloatStrict = function (value) {
        if (typeof value === 'undefined') {
            return NaN;
        }
        var ret = value.replace(',', '.');
        return $.isNumeric(ret) ? parseFloat(ret) : NaN;
    };
    $.mw_tryParseIntStrict = function (value) {
        if (typeof value === 'undefined') {
            return NaN;
        }
        var ret = value.replace(',', '.');
        return $.isNumeric(ret) ? parseInt(ret) : NaN;
    };
})(jQuery);

/* To currency formatter */
(function ($) {
    $.mw_toCurrency = function (prices, currencyCode) {
        prices = $.isArray(prices) ? prices : [prices];
        // If prices are passed as strings, ensure the decimal separator will be '.' and not ','
        var processedPrices = $.map(prices,
            function (price) {
                if (typeof (price) === 'string') {
                    return price.replace(',', '.');
                } else {
                    return price;
                }
            });

        var params = { prices: JSON.stringify(processedPrices) };
        if (currencyCode) {
            params.currency = currencyCode;
        }

        return $.get(window.R + 'handlers/public/currencyformatter.ashx', params);
    };
})(jQuery);

/* String helpers */
(function ($) {
    $.isNullOrWhiteSpace = function (str) {
        return !str || /^\s*$/.test(str);
    };

    $.isNullOrEmpty = function (str) {
        return (!str || 0 === str.length);
    };
})(jQuery);

/* Convertors */
(function ($) {
    $.base64ToBlob = function base64ToBlob(base64, mime) {
        mime = mime || '';
        var sliceSize = 1024;
        var byteChars = window.atob(base64);
        var byteArrays = [];

        for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            var slice = byteChars.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: mime });
    }
})(jQuery);